import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="dealConfirmFile";

export function insert(parameter){
  return axios({
    url: `/ws/${moduleName}`,
    method: 'post',
    data:parameter
  })
}
export function deleteByDO(fileId,dealConfirmId){
  return axios({
    url: `/ws/${moduleName}/deleteByDO/${fileId}/${dealConfirmId}`,
    method: 'delete',
  })
}

export default {
  insert,
  deleteByDO,
}